import { MainFilterInForm } from './ListTableTypes';

export const getSelectorKey = (group: MainFilterInForm): string => {
    let assumedComparator: string | undefined;
    switch (group.type) {
        case 'checkboxgroup':
        case 'date':
        case 'multiselect':
        case 'dynamicmultiselect':
        case 'dropdown':
        case 'dynamicdropdown':
            assumedComparator = '=in=';
            break;
        case 'offset-date-time':
        case 'text':
            assumedComparator = '=lk=';
            break;
        case 'number':
            assumedComparator = '=ge=';
            break;
        case 'offset-date-time-range':
        case 'daterange':
        case 'interval':
            if (group.comperator) {
                assumedComparator = group.comperator;
            }
            break;
    }

    return assumedComparator || group.comperator
        ? `${group.selector}:${group.comperator ? group.comperator : assumedComparator}`
        : group.selector;
};
